"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressFormFields = void 0;
var _commonFormFields = require("@ori/common-form-fields");
var _i18n = require("@ori/i18n");
var _Localization = require("../Localization");
var _AddressTypeLabelMapper = require("../Localization/AddressTypeLabelMapper");
var _constants = require("../constants");
var _defaultTranslations = require("../constants/defaultTranslations");
var _contexts = require("../contexts");
var _TranslationKey = require("../models/TranslationKey");
var _utils = require("../utils");
var _FieldsByConfig = require("./FieldsByConfig");
var _jsxRuntime = require("react/jsx-runtime");
const AddressFormFields = props => {
  const {
    addressAutoCompleteWithHeader,
    isFieldDisabled = false,
    enablePrimaryCheckbox,
    initialValues,
    config,
    children,
    customPrefix = '',
    formatMessage
  } = props;
  const {
    errorData
  } = (0, _contexts.useFormError)();
  const {
    streetAddress,
    zipcode,
    city,
    province,
    delivery,
    delivery2,
    delivery3,
    area,
    locality,
    district,
    region,
    country,
    addressType,
    isPrimary,
    searchOptions
  } = config;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_i18n.TranslationsNamespaceProvider, {
    namespace: _defaultTranslations.translationsNamespace,
    children: [addressAutoCompleteWithHeader, (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.CITY,
      config: city,
      initialValue: initialValues?.city,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.city,
      placeholderKey: _TranslationKey.TranslationKey.cityPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.STREET_ADDRESS,
      config: streetAddress,
      initialValue: initialValues?.streetAddress,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.streetAddress,
      placeholderKey: _TranslationKey.TranslationKey.streetPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.ZIPCODE,
      config: zipcode,
      initialValue: initialValues?.zipcode,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.zipcode,
      placeholderKey: _TranslationKey.TranslationKey.zipCodePlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.PROVINCE,
      config: province,
      initialValue: initialValues?.province,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.province,
      placeholderKey: _TranslationKey.TranslationKey.provincePlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.DELIVERY,
      config: delivery,
      initialValue: initialValues?.delivery,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.delivery,
      placeholderKey: _TranslationKey.TranslationKey.deliveryPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.DELIVERY_2,
      config: delivery2,
      initialValue: initialValues?.delivery2,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.delivery2,
      placeholderKey: _TranslationKey.TranslationKey.delivery2Placeholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.DELIVERY_3,
      config: delivery3,
      isMultiline: true,
      initialValue: initialValues?.delivery3,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.delivery3,
      placeholderKey: _TranslationKey.TranslationKey.delivery3Placeholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.AREA,
      config: area,
      initialValue: initialValues?.area,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.area,
      placeholderKey: _TranslationKey.TranslationKey.areaPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.LOCALITY,
      config: locality,
      initialValue: initialValues?.locality,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.locality,
      placeholderKey: _TranslationKey.TranslationKey.localityPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.DISTRICT,
      config: district,
      initialValue: initialValues?.district,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.district,
      placeholderKey: _TranslationKey.TranslationKey.districtPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), (0, _utils.renderFieldByConfig)({
      name: _constants.NAMES.REGION,
      config: region,
      initialValue: initialValues?.region,
      isDisabled: isFieldDisabled,
      labelKey: _TranslationKey.TranslationKey.region,
      placeholderKey: _TranslationKey.TranslationKey.regionPlaceholder,
      customPrefix,
      customErrors: errorData.customErrors,
      formatMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FieldsByConfig.CountryField, {
      initialValue: initialValues?.country,
      isDisabled: isFieldDisabled,
      isEnabledSearch: searchOptions?.isEnabled,
      ...country
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.SelectFormFieldByConfig, {
      name: _constants.NAMES.ADDRESS_TYPE,
      isDisabled: isFieldDisabled,
      labelMapper: _AddressTypeLabelMapper.AddressTypeLabelMapper,
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _defaultTranslations.defaultTranslations.addressType,
        id: _TranslationKey.TranslationKey.addressType
      }),
      initialValue: initialValues?.addressType,
      customMaxWidth: "100%",
      ...addressType
    }), enablePrimaryCheckbox ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FieldsByConfig.PrimaryCheckbox, {
      name: _constants.NAMES.IS_PRIMARY,
      isDisabled: isFieldDisabled || initialValues?.isPrimary,
      initialValue: initialValues?.isPrimary ?? false,
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        defaultMessage: _defaultTranslations.defaultTranslations.isPrimary,
        id: _TranslationKey.TranslationKey.isPrimary
      }),
      ...isPrimary
    }) : null, children]
  });
};
exports.AddressFormFields = AddressFormFields;
//# sourceMappingURL=AddressFormFields.js.map